<template>
    <b-container>
        <b-card v-if="contactId != null">
        <b-breadcrumb>
            <b-breadcrumb-item :to="{name: 'ward-list', params: { wardId: wardId}}">Back to {{ward.ward_name}}</b-breadcrumb-item>
            <b-breadcrumb-item active>{{contact.first_name}} {{contact.last_name}}</b-breadcrumb-item>
        </b-breadcrumb>
        <b-row v-if="aux_organizations.length > 0">
            <b-col>
        <h1>{{contact.first_name}} {{contact.last_name}}</h1>
        <h4>Phone No: <font-awesome-icon :icon="(contact.send_through_whatsapp) ? 'fa-brands fa-whatsapp' : 'sms'" /> {{formatPhoneNumber(contact.phone_number)}}</h4>
        <h4>Ward Name: {{contact.ward.ward_name}}</h4>
        <h4 v-if="contact.title">Title/Calling: {{ contact.title }}</h4>
                <b-button
                    :to="{name: 'ward-contact', params: { 'wardId': wardId, 'contactId': contactId, 'stakeId': contact.stake_id}}"
                    variant="outline-secondary">
                <font-awesome-icon v-if="isInRole('canModifyContact')" icon="edit" />
                Edit
                </b-button>
                <b-button @click="deleteContact" class="float-right" type="button" variant="danger" v-if="contactId!==null && isInRole('canModifyContact') && contact.disabled">
                    <font-awesome-icon v-if="isInRole('canModifyContact')" icon="trash" />
                    Delete
                    </b-button>
            </b-col>
            <b-col>
            <h6>Status: <b-badge :variant="(contact.disabled)?'secondary':'info'">{{(contact.disabled)?'DISABLED':'ENABLED'}}</b-badge></h6>
            <h6>Consent State: <b-badge :variant="(contact.consent_state=='ENROLLED')?'success':'danger'">{{contact.consent_state}}</b-badge></h6>
            <h6>URL Shortening: <b-badge :variant="(!contact.short_url_encode)?'secondary':'info'">{{(!contact.short_url_encode)?'DISABLED':'ENABLED'}}</b-badge></h6>
            <h6 v-if="ward.whatsapp_service_enabled">WhatsApp: <b-badge :variant="(!contact.send_through_whatsapp)?'secondary':'info'">{{(!contact.send_through_whatsapp)?'DISABLED':'ENABLED'}}</b-badge></h6>
            <h6>Primary Org/Group: {{getOrganizationInfo(contact.primary_organization).text}}</h6>
            <h6 v-if="contact.aux_organization.length >0 && countInAuxCompositeOrgs(contact.primary_organization) > 0" >Auxilary Orgs/Groups: {{flattenInAuxCompositeOrgs(contact.primary_organization)+','+flattenAuxOrganizations(contact.aux_organization)}}</h6>
            <h6 v-if="contact.aux_organization.length >0 && countInAuxCompositeOrgs(contact.primary_organization) === 0" >Auxilary Orgs/Groups: {{flattenAuxOrganizations(contact.aux_organization)}}</h6>
            <h6 v-if="contact.aux_organization.length ===0 && countInAuxCompositeOrgs(contact.primary_organization) > 0" >Auxilary Orgs/Groups: {{flattenInAuxCompositeOrgs(contact.primary_organization)}}</h6>
            <h6>Consent Updated: {{contact.consent_updated_on!==null?$moment.utc(contact.consent_updated_on).fromNow():'Not Available'}}</h6>
            <h6 v-if="contact.carrier_info!==null">Carrier Information:</h6>
            <h6 v-if="contact.carrier_info!==null">Name: <b-badge variant="primary">{{contact.carrier_info.name}}</b-badge> Type: <b-badge variant="secondary">{{contact.carrier_info.type }}</b-badge></h6>

            </b-col>
        </b-row>
        </b-card>
        <b-card class="mt-3">
        <b-row>
            <b-col>
            <b-form @submit="onSubmit">
                <b-form-group
                    id="input-group-1"
                    label="Note:"
                    label-for="input-1"
                    description="Please do not add sensitive information.">
                    <b-form-textarea
                      id="textarea"
                      v-model="noteText"
                      placeholder="A manual note to be added"
                      rows="3"
                      max-rows="3"
                      required
                    ></b-form-textarea>
                </b-form-group>
                <b-button type="submit" variant="secondary" >Add Note</b-button>
            </b-form>
                <b-table
                    :fields="table.fields"
                    :items="table.items"
                    class="mb-3 mt-3"
                    striped
                    responsive
                    show-empty
                    empty-text="No Notes to show"
                    outlined>
                    <template #table-busy>
                      <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Loading...</strong>
                      </div>
                    </template>
                    <template #cell(contact_note)="row">
                        <pre class="text-left">{{row.item.contact_note}}</pre>
                    </template>
                     <template #cell(created_on)="row">
                         <span :id="'tooltip-contact-note-created' + row.index">{{$moment.utc(row.item.created_on).local().fromNow()}}</span>
                        <b-tooltip :target="'tooltip-contact-note-created' + row.index" triggers="hover">
                            {{$moment.utc(row.item.created_on).local().format('llll')}}
                        </b-tooltip>
                        </template>
                </b-table>
            </b-col>
        </b-row>
        <b-row>
            <b-col align="center">
                <b-button-group v-if="pages.length>1">
                    <b-button @click="searchNotes(currentPage-1)">Prev</b-button>
                    <b-button @click="searchNotes(currentPage+1)">Next</b-button>
                </b-button-group>
            </b-col>
        </b-row>
        </b-card>
    </b-container>
</template>
<script>
import { WardApi } from "@/app/wards/wardApi";
import { userMixin } from "@/mixins/userMixin";
import handleError from "@/errorHandler";
export default {
    name: "ContactNoteList",
    props: {
        wardId: {
            type: String,
            required: false,
            default: null
        },
        contactId: {
            type: String,
            required: false,
            default: null
        }
    },
    mixins: [userMixin],
    data () {
        return {
            contact :{
                first_name: null,
                last_name: null,
                phone_number:null,
                ward: {
                    ward_name:null
                }

            },
            ward: {
                ward_name: null,
                whatsapp_service_enabled: false,
            },
            noteText: null,
            nextPage: {
                aux_id: null,
                pk_id: null,
                gsi_pk: null,
                gsi_sk: null
            },
            prevPage: {
                aux_id: null,
                pk_id: null,
                gsi_pk: null,
                gsi_sk: null
            },
            pages: [],
            currentPage: 0,
            lastPage: 0,
            table: {
                id: "contact-note_list",
                fields: [
                    {
                        key: "contact_note",
                        label: "Event/Note"
                    },
                    {
                        key: "created_on",
                        label: "Created"
                    },
                    {
                        key: "added_by.username",
                        label: "Added By"
                    }
                ],
                items: [],
                isBusy: false,
                totalRows: 0,
                page: {
                    index: 1,
                    size: 5
                }

            },
            organizations : [],
            aux_organizations:[],

        }
    },
    async mounted() {
        if(this.contactId!==null)
            this.contact = await this.getContact();
        if(this.wardId!==null)
            await this.getOrganizations();
        this.pages.push(this.nextPage);
        await this.searchNotes(0);

    },
    methods: {
        async getOrganizations() {
            try{
                const { data } = await WardApi.getWardOrganizations(this.wardId);
                //console.log(data);
                this.ward = data.ward;
                this.organizations = data.org_list;
                data.org_list.forEach(x=>{
                    if(!x.primary){
                        this.aux_organizations.push({
                            value: x.org_code,
                            text: x.org_name

                        });
                    }else{
                        this.aux_organizations.push({
                            value: x.org_code,
                            text: x.org_name

                        });
                    }
                });
            }catch(e) {
                handleError(e, "Error getting organizations");
            }

        },
        getOrganizationInfo(value) {
            var i;
            for (i=0; i < this.aux_organizations.length; i++) {
                if(this.aux_organizations[i].value==value)
                    return this.aux_organizations[i];
            }
        },
        flattenAuxOrganizations(list_of_orgs) {
            if(list_of_orgs === undefined) return '';
            if(list_of_orgs.length==0) return '';
            return list_of_orgs.map(x=>
            {
                let orgInfo = this.getOrganizationInfo(x);
                return (orgInfo === undefined) ? x: orgInfo.text;
            }).join(', ');

        },
        flattenInAuxCompositeOrgs(primary_org) {
            let orgs = [];
            this.organizations.forEach(x=>{
                if (x.composite_orgs!==null) {
                    if( x.composite_orgs.includes(primary_org))
                    {
                        orgs.push(x.org_name);
                    }
                }
            });
            return orgs.length >0 ? orgs.join(',' ) : null ;
        },
        countInAuxCompositeOrgs(primary_org)
        {
            let orgs = [];
            this.organizations.forEach(x=>{
                if (x.composite_orgs!==null) {
                    if( x.composite_orgs.includes(primary_org))
                    {
                        orgs.push(this.org_name);
                    }
                }
            });
            return orgs.length;
        },
        async getContact() {
            try{
                const { data } = await WardApi.getWardContact(this.wardId, this.contactId);
                this.ward = data.ward;
                return data;
            }catch (e) {
                handleError(e, "Error getting contact information");
            }
        },
        async onSubmit(event) {
            event.preventDefault();
            try {
                const payload = {
                    contact_note: this.noteText
                };
                //console.log(payload);
                const { data } = await WardApi.createContactNote(this.wardId, this.contactId, payload);
                this.$toast.success("Successfully added contact note");
                await this.refresNoteList();
                this.noteText = null;
            } catch(e) {
                handleError(e, "Error trying to add a note");
            }


        },
        async searchNotes(page) {
            if(page < 0) {
                return;
            }
            if(page > this.pages.length - 1) {
                return;
            }
            const payload =  this.pages[page];
            this.table.isBusy = true;
            try {
                const { data } = await WardApi.searchContactNotes(this.wardId, this.contactId, payload);
                if (data.last_evaluated_key !== null) {
                    if(!this.existInPageList(data.last_evaluated_key, this.pages))
                        this.pages.push(data.last_evaluated_key);
                }
                this.table.items = data.note_list;
                this.table.isBusy = false;
                this.currentPage = page;
            } catch (e) {
                handleError(e, "Failed to fetch contact notes");
            }
        },
        existInPageList(obj, list) {
            if(list.length==0) return false;
            var i;
            for (i = 0; i < list.length; i++) {
                if(list[i].pk_id === obj.pk_id && list[i].aux_id === obj.aux_id) {
                    return true;
                }
            }
            return false;
        },
        async refresNoteList() {
            this.pages = [];
            this.currentPage = 0;
            this.lastPage = 0;
            this.pages.push(this.nextPage);
            await this.searchNotes(0);
        },
        async deleteContact() {
            try{
                if(this.contactId!==null && this.contact.disabled){
                    const { data } = await WardApi.deleteWardContact(this.wardId, this.contactId);
                    this.$toast.success("Successfully deleted ward contact");
                    this.$router.push({ name: 'ward-list',params: { wardId: this.wardId}});

                }
            } catch(e) {
                handleError(e, "Error trying to process contact request");
            }


        }
    }


}
</script>
<style lang="scss" scoped>
    pre {
       overflow-x: auto;
       white-space: pre-wrap;
       white-space: -moz-pre-wrap;
       white-space: -pre-wrap;
       white-space: -o-pre-wrap;
       word-wrap: break-word;
    }
</style>
